<!-- [class.isVisible]="isPrintableShown" -->
<div class="printable-offer isVisible" *ngIf="selectedOffer">
  <div class="offer-id">
    <img class="site-logo" src="/assets/images/logos_logo.png"/> {{'OFFER' | translate|uppercase}} №{{selectedOffer.id}}
  </div>
  <img class="offer-main-picture" *ngIf="selectedOffer.pictures[0]" src={{selectedOffer.pictures[0]}}
       alt="property picture"/>
  <img class="offer-main-picture" *ngIf="!selectedOffer.pictures[0]" src="{{noImageAvailableUrl}}"
       alt="property picture"/>

  <div class="offer-all-stats-key-values-pairs">
    <div class="offer-stats-pair">
      <div class="offer-field-key-text">{{'OFFER_TYPE' | translate}}:</div>
      <div class="offer-field-value-text">{{offerType | translate | titlecase}}</div>
    </div>
    <div class="offer-stats-pair">
      <div class="offer-field-key-text">{{'LOCATION' | translate}}:</div>
      <div class="offer-field-value-text">{{selectedOffer.city | translatedb }}</div>
    </div>
    <div class="offer-stats-pair">
      <div class="offer-field-key-text">{{'AREA' | translate}}:</div>
      <div class="offer-field-value-text">{{selectedOffer.area | translatedb }}</div>
    </div>
    <div class="offer-stats-pair">
      <div class="offer-field-key-text">{{'PROPERTY_TYPE' | translate}}:</div>
      <div class="offer-field-value-text">{{selectedOffer.subType | translatedb }}</div>
    </div>
    <div class="offer-stats-pair">
      <div class="offer-field-key-text">{{'SPACE' | translate}}:</div>
      <div class="offer-field-value-text">{{selectedOffer.space}} {{"SQUARE_METERS" | translate }}
      </div>
    </div>
    <div class="offer-stats-pair" *ngIf="selectedOffer.buildingType &&
                                             selectedOffer.type.valueBg !== 'поземлени имоти' ">
      <div class="offer-field-key-text">{{'BUILDING_TYPE' | translate}}:</div>
      <div class="offer-field-value-text">{{selectedOffer.buildingType | translatedb }}</div>
    </div>
    <div class="offer-stats-pair" *ngIf="selectedOffer.yearOfBuilt &&
                                             selectedOffer.type.valueBg !== 'поземлени имоти' ">
      <div class="offer-field-key-text">{{'YEAR_OF_BUILD' | translate}}:</div>
      <div class="offer-field-value-text"> {{selectedOffer.yearOfBuilt}}</div>
    </div>
    <div class="offer-stats-pair" *ngIf="selectedOffer.floor &&
                                               selectedOffer.type.valueBg !== 'гаражи' &&
                                               selectedOffer.type.valueBg !== 'поземлени имоти' ">
      <div class="offer-field-key-text">{{'FLOOR' | translate}}:</div>
      <div class="offer-field-value-text">{{selectedOffer.floor | translatedb}}</div>
    </div>
    <div class="offer-stats-pair" *ngIf="selectedOffer.specifications && selectedOffer.specifications.length>0">
      <div class="offer-field-key-text">{{"SPECIFICATIONS" | translate}}:</div>
      <div class="offer-field-value-text">{{selectedOffer.getTranslatedSpecificationsString() | translatedb}}
      </div>
    </div>
    <div class="offer-stats-pair">
      <div class="offer-field-key-text">{{'PRICE' | translate}}:</div>
      <div
        class="offer-field-value-text">{{ offersService.getConvertedPrice(selectedOffer.price) }} {{ selectedCurrency | translate}}
      </div>
    </div>
  </div>

  <div class="offer-description-container">
    <div class="offer-description-header">
      {{'DESCRIPTION' | translate}}:
    </div>
    <div class="offer-description">{{selectedOffer.description | translatedb}}</div>
  </div>
  <div class="offer-user-container" *ngIf="true">
    <div class="offer-user-header">{{'CONTACT_PERSON' | translate}}:</div>
    <img class="offer-user-picture" [src]="selectedUser.picture" alt="user picture"/>
    <div class="offer-user-info-container">
      <div class="offer-user-name">{{selectedUser.name | translatedb}}</div>
      <div class="offer-user-phone-number">{{'PHONE' |translate | lowercase}}: {{selectedUser.phoneNumber}}
      </div>
      <div class="offer-user-mobile-number">{{'MOIBILE' |translate | lowercase}}: {{selectedUser.mobileNumber}}
      </div>
      <div class="offer-user-email">{{'EMAIL' |translate | lowercase}}: {{selectedUser.email}}</div>
    </div>
  </div>
</div>
